// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "304" ? "rich-text-editor" : chunkId) + "." + {"304": "6d5a1ce0bb75aed8","959": "9aed2f9e062663a9",}[chunkId] + ".js"
}